'use strict';
import Vue from 'vue';
import ElementUI from 'element-ui';
import VCharts from 'v-charts';
// import Prints from '@/utils/print';
// import PrintCanvas from '@/plugins/print';
import Print from 'vue-print-nb';
import HtmlToPdf from '@/plugins/htmlToPdf.js';
// import Icon from 'vue-awesome/components/Icon';
// import 'vue-awesome/icons';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App';
import router from './router';
import store from './store';
import preventRepeatClick from '@/common/preventRepeatClick/preventRepeatClick.js';
import './directive';
import '@/components/index.js'; // 自动注册自定义组件
import BusinessAppMenu from '@/pages/business/BusinessApplication/BusinessAppMenu';
import WorkflowEditor from '@/pages/process/ProcessEditor/WorkflowEditor';
import ApprovalPop from '@/components/ApprovalPop';
import ProcessSetting from '@/pages/process/MyProcess/ProcessSetting';
import ProcessDetail from '@/pages/process/MyProcess/ProcessDetail';
import FieldItemArchive from '@/components/FieldItem/FieldItemArchive';
import elTableInfiniteScroll from 'el-table-infinite-scroll';
import ProcessDiagram from '@/pages/process/MyProcess/ProcessDiagram';
import ProcessInstancePop from '@/pages/process/ProcessTemplate/ProcessInstancePop.vue';
import TaskDetail from '@/pages/process/MyTask/TaskDetail';
import ModelDetail from '@/pages/business/BusinessApplication/ModelDetail';
import 'default-passive-events';

import './assets/iconfont/iconfont.css';// 阿里矢量图自定义图标库
Vue.use(elTableInfiniteScroll);
// import global from '@/utils/global';
// Vue.prototype.global = global;
Vue.use(VCharts);
// Vue.use(Prints); // 注册
// Vue.use(PrintCanvas); // 注册
Vue.use(Print); // 注册
Vue.use(HtmlToPdf); // 注册
Vue.use(preventRepeatClick); // 防止按钮重复点击
// Vue.component(VePie.name, VePie);
// ElementUI.Dialog.props.closeOnClickModal.default = false;

Vue.use(ElementUI, {
    size: 'small'
});
Vue.component('BusinessAppMenu', BusinessAppMenu);
Vue.component('WorkflowEditor', WorkflowEditor);
Vue.component('ApprovalPop', ApprovalPop);
Vue.component('ProcessSetting', ProcessSetting);
Vue.component('ProcessDetail', ProcessDetail);
Vue.component('FieldItemArchive', FieldItemArchive);
Vue.component('ProcessDiagram', ProcessDiagram);
Vue.component('ProcessInstancePop', ProcessInstancePop);
Vue.component('TaskDetail', TaskDetail);
Vue.component('ModelDetail', ModelDetail);

// Vue.component('icon', Icon);

Vue.config.devtools = true;

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#content');



// WEBPACK FOOTER //
// ./src/main.js